import React from 'react';
import ReactDOM from 'react-dom/client';
import { StoreProvider, store } from '@link/tokyo-subway-ticket/stores';
import '@link/tokyo-subway-ticket/i18n';
import '@link/tokyo-subway-ticket/styles/index.css';
import App from '@link/tokyo-subway-ticket/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <StoreProvider value={store}>
      <App />
    </StoreProvider>
  </React.StrictMode>
);
